<template>
  <b-row>
    <b-col
      cols="12"
      md="6"
    >
      <b-overlay
        :show="isPending"
        rounded="sm"
      >
        <b-card>
          <validation-observer ref="simpleRules">
            <b-form @submit.prevent="validationForm">

              <!-- Nama -->
              <b-form-group
                label="Nama"
                label-for="v-name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Nama"
                  rules="required"
                >
                  <b-form-input
                    id="v-name"
                    v-model="form.name"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Button -->
              <div class="d-flex justify-content-end mt-3">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  :disabled="isSubmitting"
                >
                  <b-spinner
                    v-if="isSubmitting"
                    small
                  />
                  {{ isSubmitting ? "Menyimpan" : "Simpan" }}
                </b-button>
              </div>
            </b-form>
          </validation-observer>
        </b-card>
      </b-overlay>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import {
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BSpinner,
  BOverlay,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

// Vee Validate
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, integer, minValue } from '@validations'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BOverlay,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        name: '',
      },
      required,
      minValue,
      integer,
      isPending: false,
      isSubmitting: false,
    }
  },
  computed: {
    ...mapState('faqCategory', ['faqCategory']),
    faqCategoryId() {
      if (this.isEdit) {
        return this.$route.params.id
      }
      return null
    },
  },
  async created() {
    this.isPending = true

    if (this.isEdit) {
      await this.getCategoryFaq({ id: this.faqCategoryId })
      this.fillData()
    }

    this.isPending = false
  },
  methods: {
    ...mapActions('faqCategory', ['createCategoriesFaq', 'getCategoryFaq', 'updateCategoryFaq']),
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.handleSubmit()
        }
      })
    },
    async handleSubmit() {
      this.isSubmitting = true

      if (!this.isEdit) {
        await this.createCategoriesFaq(this.form)
      } else {
        await this.updateCategoryFaq({ faqCategoryId: this.faqCategoryId, data: this.form })
      }

      this.isSubmitting = false
      this.$router.push('/faq-categories')
    },
    // Edit State Only
    fillData() {
      this.form.name = this.faqCategory.data.name
    },
  },
}
</script>

<style lang="scss">
.image-preview {
    width: 102px;
    height: 102px;
    background-color: white;
    border: 1px solid red;
    position: relative;
    img {
        left: 0;
        top: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
}
</style>
